import React from 'react';
import { getDate, getTime } from '../../helpers/date';
import currencyFormatter from '../../helpers/currencyFormatter';

function HistoryItem({ date, amount, theme, cashier_credit }) {
  return (
    <tr className='history-item'>
      <td className='history-date'>{getDate(date)}</td>
      <td className='history-time'>{getTime(date)}</td>
      <td className='history-type'></td>
      <td className='history-type'></td>
      <td className={`history-value ${theme}`}>{currencyFormatter(amount)}</td>
      <td className='history-value history-value-credit'>{currencyFormatter(cashier_credit)}</td>
    </tr>
  );
}

export default HistoryItem;
